import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useSelector } from 'react-redux'
import { setPossibleColumns } from 'store/CustomReports/actions'
import { removeNumberOfUsers } from 'store/CustomReports/actions'
import { includeNumberOfUsers } from 'store/CustomReports/actions'
import CourseReportType from './CourseReportType'

export const CR_STATUS_FIELDS = [
  'inProgress',
  'needsManagerApproval',
  'certified',
  'failed',
  'notStarted',
  'quizPending',
]

export const stepProgresses = {
  0: [
    'General Type',
    'Course Type',
    'Select Course',
    'Locations',
    'Roles',
    'Generate Report',
  ],
  1: ['General Type', 'Course Type', 'Select Courses', 'Generate Report'],
  2: [
    'General Type',
    'Course Group Type',
    'Select Course Group',
    'Locations',
    'Roles',
    'Generate Report',
  ],
  3: [
    'General Type',
    'Course Group Type',
    'Select Course Groups',
    'Generate Report',
  ],
}

export const mandatorySlides = {
  0: [1, 2, 3],
  1: [3],
  2: [1, 2, 3],
  3: [3],
}

export const CR_INCLUDE_USERS_VALUE = '(# users)'

const possibleCourseColumns = [
  { headerName: 'In Progress', field: 'inProgress', val: 'TBD%' },
  {
    headerName: 'Manager Approval',
    field: 'needsManagerApproval',
    val: 'TBD%',
  },
  { headerName: 'Certified', field: 'certified', val: 'TBD%' },
  { headerName: 'Failed', field: 'failed', val: 'TBD%' },
  { headerName: 'Not Started', field: 'notStarted', val: 'TBD%' },
  { headerName: 'Quiz Pending', field: 'quizPending', val: 'TBD%' },
  {
    headerName: 'Include number of users for each status',
    id: 'includeUsers',
    onSelectFn: () =>
      includeNumberOfUsers(CR_STATUS_FIELDS, CR_INCLUDE_USERS_VALUE),
    onDeselectFn: () => removeNumberOfUsers(CR_INCLUDE_USERS_VALUE),
  },
  { headerName: 'Average Time Spent', field: 'averageTime', val: '# mins' },
  { headerName: 'Quiz pass percentage', field: 'quizPassed', val: 'TBD%' },
  {
    headerName: 'First-attempt quiz pass',
    field: 'firstAttemptPassed',
    val: 'TBD%',
  },
  {
    headerName: 'Checklist pass percentage',
    field: 'checklistPassed',
    val: 'TBD%',
  },
]

const possibleCourseGroupColumns = [
  { headerName: 'In Progress', field: 'inProgress', val: 'TBD%' },
  { headerName: 'Certified', field: 'certified', val: 'TBD%' },
  { headerName: 'Not Started', field: 'notStarted', val: 'TBD%' },
  {
    headerName: 'Include number of users for each status',
    id: 'includeUsers',
    onSelectFn: () =>
      includeNumberOfUsers(CR_STATUS_FIELDS, CR_INCLUDE_USERS_VALUE),
    onDeselectFn: () => removeNumberOfUsers(CR_INCLUDE_USERS_VALUE),
  },
]

export const columns = [
  {
    id: 1,
    default: [
      { headerName: 'Course', field: 'name' },
      { headerName: 'Location', field: 'Location' },
      { headerName: 'Area', field: 'Area' },
      { headerName: 'Region', field: 'Region' },
    ],
    possible: possibleCourseColumns,
  },
  {
    default: [{ headerName: 'Course', field: 'name' }],
    possible: possibleCourseColumns,
  },
  {
    default: [
      { headerName: 'Group', field: 'name' },
      { headerName: 'Location', field: 'Location' },
      { headerName: 'Area', field: 'Area' },
      { headerName: 'Region', field: 'Region' },
    ],
    possible: possibleCourseGroupColumns,
  },
]

function Data() {
  const dispatch = useDispatch()
  const {
    previewColumns,
    selectedReportType,
    selectedCourseReportType,
    selectedSingleCourse,
    exactReportType,
    editingReport,
    previewRows,
  } = useSelector((store) => store.customReports)

  const includeUsers = previewColumns.some((c) => !c.field)

  const [possibleColumns, setColumns] = useState(columns)
  const updateColumns = (callback) => {
    setColumns((prevColumns) =>
      prevColumns?.map((col, index) =>
        index === exactReportType
          ? {
              ...col,
              possible: col.possible?.map(callback),
            }
          : col
      )
    )
  }

  useEffect(() => {
    updateColumns((item) => {
      return CR_STATUS_FIELDS.includes(item.field)
        ? {
            ...item,
            val: includeUsers
              ? `${item.val} ${CR_INCLUDE_USERS_VALUE}`
              : item.val.replace(` ${CR_INCLUDE_USERS_VALUE}`, ''),
          }
        : item
    })
  }, [includeUsers, exactReportType])

  useEffect(() => {
    if (editingReport && includeUsers && previewRows.length) {
      dispatch(includeNumberOfUsers())
    }
  }, [editingReport, includeUsers, dispatch, previewRows.length])

  useEffect(() => {
    if (
      exactReportType === 0 &&
      'hasChecklist' in selectedSingleCourse &&
      !selectedSingleCourse?.hasChecklist
    ) {
      updateColumns((item) =>
        item.field === 'checklistPassed' ? { ...item, disabled: true } : item
      )
    }
  }, [exactReportType, selectedSingleCourse])

  useEffect(() => {
    if (
      exactReportType === 0 &&
      'hasQuiz' in selectedSingleCourse &&
      !selectedSingleCourse?.hasQuiz
    ) {
      updateColumns((item) =>
        ['firstAttemptPassed', 'quizPassed'].includes(item.field)
          ? { ...item, disabled: true }
          : item
      )
    }
  }, [exactReportType, selectedSingleCourse])

  useEffect(() => {
    dispatch(setPossibleColumns(possibleColumns?.[exactReportType]?.possible))
  }, [possibleColumns, dispatch, exactReportType])

  return null
}

export default Data
